module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "user-view"
  }, [_c('div', {
    staticClass: "user-view__user-form"
  }, [_c('span', {
    on: {
      "click": function (e) { return _vm.show != _vm.show; }
    }
  }, [_c('span', {
    staticClass: "user-view__collapse-btn"
  }, [_c('collapse-arrows', {
    attrs: {
      "down": !_vm.show
    },
    nativeOn: {
      "click": function($event) {
        return (function (e) { return (_vm.show = !_vm.show); }).apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "user-view__form_label"
  }, [_vm._v("Create User Form")])], 1)]), _vm._v(" "), (_vm.show) ? _c('user-form') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user-view__user-list"
  }, [_c('user-list', {
    attrs: {
      "copiedUserList": _vm.copiedUserList,
      "rolesList": _vm.rolesList
    }
  })], 1), _vm._v(" "), _c('action-modal', {
    ref: "deleteUserModal",
    attrs: {
      "buttonText": "Delete",
      "object": _vm.userToDelete
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("\n    Are you sure you want to delete user\n    "), _c('span', {
    staticClass: "delete-target-modal__delete-target-name"
  }, [_vm._v("\n      " + _vm._s(this.userToDelete.first_name) + " " + _vm._s(this.userToDelete.last_name) + "\n    ")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5178971e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/permissions/UsersView.vue
// module id = 1900
// module chunks = 0